<template>
  <press-center
      :in-category="915"
      current-url="Coral Club"
      in-name="coral_club"
  />
</template>

<script>
import PressCenter from "@/views/PressCenter";
export default {
  name: "PressCoralClub",
  components: {PressCenter},
  mounted () {
  }
}
</script>

<style scoped>

</style>
